import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocument = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14 2.5H6C4.9 2.5 4 3.4 4 4.5V20.5C4 21.6 4.89 22.5 5.99 22.5H18C19.1 22.5 20 21.6 20 20.5V8.5L14 2.5ZM16 12.5H8V14.5H16V12.5ZM16 16.5H8V18.5H16V16.5ZM6 20.5H18V9.5H13V4.5H6V20.5Z",
			fill: "#2771bb"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0",
			"mask-type": "alpha",
			maskUnits: "userSpaceOnUse",
			x: 4,
			y: 2,
			width: 16,
			height: 21,
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M14 2.5H6C4.9 2.5 4 3.4 4 4.5V20.5C4 21.6 4.89 22.5 5.99 22.5H18C19.1 22.5 20 21.6 20 20.5V8.5L14 2.5ZM16 12.5H8V14.5H16V12.5ZM16 16.5H8V18.5H16V16.5ZM6 20.5H18V9.5H13V4.5H6V20.5Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", { mask: "url(#mask0)" })
	]
});
const ForwardRef = forwardRef(SvgDocument);
export default ForwardRef;
